<template>
    <v-dialog v-model="showsDialog" dark no-click-animation fullscreen overlay-color="black" overlay-opacity="0.4" content-class="v-dialog--full">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, setIndex }" />
        </template>
        <div class="v-dialog--full__container">
            <div class="gallery-imgs-modal">
                <div class="gallery-imgs-modal__con">
                    <v-btn large icon text class="v-btn--none-active-bg" @click="goPrev" :disabled="disable_prev">
                        <i class="icon icon-arrow2-left"></i>
                    </v-btn>
                    <div class="gallery-imgs-modal__img">
                        <v-tabs-items :value="selectedIndex">
                            <v-tab-item v-for="(img, index) in imgs" :key="img.url" :value="index">
                                <template v-if="disableLink">
                                    <v-img :src="img.url" :aspect-ratio="1 / 1" contain />
                                </template>
                                <a v-else :href="img.url" target="_blank" rel="noopener noreferrer">
                                    <v-img :src="img.url" :aspect-ratio="1 / 1" contain />
                                </a>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                    <v-btn large icon text class="v-btn--none-active-bg" @click="goNext" :disabled="disable_next">
                        <i class="icon icon-arrow2-right"></i>
                    </v-btn>
                </div>
                <div class="gallery-imgs-modal__thumb-wrap">
                    <div v-for="(img, index) in imgs" :key="img.url" @mouseenter="setIndex(img)" :class="{ 'active' : selectedIndex == index }" class="gallery-imgs-modal__thumb">
                        <v-img :src="img.url" :aspect-ratio="1 / 1" width="100%" />
                    </div>
                    <!-- <div v-for="(img, index) in imgs" :key="img.url" style="position: relative" @mouseenter="setIndex(img)">
                        <v-fade-transition>
                            <v-overlay v-show="selectedIndex == index" absolute z-index="0" color="white" opacity="1" />
                        </v-fade-transition>
                        <v-img :src="img.url" :aspect-ratio="1 / 1" width="100%" />
                    </div> -->
                </div>
            </div>
            <v-fade-transition hide-on-leave>
                <div v-show="showsCloseBtn" @click="showsDialog = false" class="v-dialog--full__close">
                    <i class="icon icon-close"></i>
                </div>
            </v-fade-transition>
        </div>
    </v-dialog>
</template>

<script>
export default {
    props: {
        imgs: { type: Array, default: () => [] },
        disableLink: { type: Boolean, default: false },
    },
    data: () => ({
        showsDialog: false,
        showsCloseBtn: false,
        selectedIndex: 0,
    }),
    computed: {
        disable_prev() {
            return this.selectedIndex < 1;
        },
        disable_next() {
            return this.selectedIndex >= this.imgs.length - 1;
        },
    },
    watch: {
        showsDialog() {
            if (this.showsDialog) setTimeout(() => (this.showsCloseBtn = true), 500);
            else this.showsCloseBtn = false;
        },
    },
    methods: {
        setIndex({ url }) {
            this.selectedIndex = this.imgs.findIndex((img) => img.url == url);
        },
        goPrev() {
            if (this.selectedIndex > 0) this.selectedIndex -= 1;
        },
        goNext() {
            if (this.selectedIndex < this.imgs.length - 1) this.selectedIndex += 1;
        },
    },
};
</script>

<style>
</style>